<template>
  <div class="app-mnp-in-wrapper">
    <div v-if="showMNP">
      <b-row class="form-stepper">
        <b-col class="start-step"
               @click="goToStepBefore(beforeStepperData, startStepName)"
               v-bind:class="{active: showStep(startStepName), 'before-active': beforeStepperData }"
        >
          <slot name="lblStartStep">
            <span>1.</span>Rufnummernmitnahme
          </slot>
        </b-col>
        <b-col class="data-step"
               @click="goToStepBefore(beforeStepperSummary,dataStepName)"
               v-bind:class="{active: showStep(dataStepName), 'before-active': beforeStepperSummary }"
        >
          <slot name="lblDataStep">
            <span>2.</span>Ihre Kundendaten
          </slot>
        </b-col>
        <b-col class="summary-step"
               v-bind:class="{ active: showStep(summaryStepName)}"
        >
          <slot name="lblSummaryStep">
            <span>3.</span>Zusammenfassung
          </slot>
        </b-col>
      </b-row>
      <MnpInStart
        v-if="showStep(startStepName)"
        :portation-time.sync="portationTime"
        :portation-consent.sync="portationConsent"
        :next-step="dataStepName"
      >
        <template v-for="slot in possibleChildSlotsFor('Start')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </MnpInStart>
      <MnpInData
        v-if="showStep(dataStepName)"
        :portation-time.sync="portationTime"
        :previous-step="startStepName"
        :next-step="summaryStepName"
      >
        <template v-for="slot in possibleChildSlotsFor('Data')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </MnpInData>
      <MnpInSummary
        v-if="showStep(summaryStepName)"
        :previous-step="dataStepName"
      >
        <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </MnpInSummary>
    </div>
    <div v-else>
      <slot name="infoMnpInNotAvailable">
        <h2>Rufnummernmitnahme in diesem Tarif nicht möglich</h2>
      </slot>
    </div>
  </div>
</template>

<script>
import MnpInStart, { stepName as startStepName } from '@/components/process/generic/Mnp/MnpIn/Start.vue'
import MnpInData, { stepName as dataStepName } from '@/components/process/generic/Mnp/MnpIn/Data.vue'
import MnpInSummary, { stepName as summaryStepName } from '@/components/process/generic/Mnp/MnpIn/Summary.vue'
import slotProxy from '@/mixins/slotProxy'
import processWrapper from '@/mixins/processWrapper'
import transaction from '@/mixins/transaction'
import { mapGetters, mapMutations } from 'vuex'
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../../helper/wrapGQLQuery'
import extraData from '../../../../../../mixins/extraData'

export default {
  name: 'MnpInWrapper',
  import: {
    startStepName,
    dataStepName,
    summaryStepName
  },
  data () {
    return {
      portationTime: 'CONTRACT_END',
      portationConsent: false,
      tariffs: null
    }
  },
  methods: {
    goToStepBefore (active, step) {
      if (active) {
        this.goToStep(step)
      }
    },
    ...mapMutations('mnpIn', [
      'goToStep'
    ])
  },
  computed: {
    beforeStepperData: function () {
      return this.beforeStepperSummary || this.showStep(dataStepName)
    },
    beforeStepperSummary: function () {
      return this.showStep(summaryStepName)
    },
    ...mapGetters('mnpIn', [
      'showMnpInView'
    ]),
    tariffsExtra: function () {
      return this.extraData.find(item => item.id === this.tariffs?.bookedTariff?.tariffId)
    },
    showMNP: function () {
      return this.tariffsExtra?.type !== 'year'
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(gql`query MnpIn{
        tariffs {
          bookedTariff {
            tariffId
          }
        }
      }`, this, 'tariffs')
    }
  },
  components: {
    MnpInStart,
    MnpInData,
    MnpInSummary
  },
  mixins: [
    transaction('mnpIn'),
    slotProxy(['Stepper']),
    processWrapper('showMnpInView'),
    extraData()
  ]
}
</script>
